import $ from 'jquery';
import 'jquery.scrollbar';
import bindEvent from '../../scripts/util/bindEvent';
import isElement from '../../scripts/util/isElement';

const selectors = {
	pass: '.js-input-pass',
	show: '.js-show-password',
	textarea: '.js-textarea',
	select: '.js-select-native',
	jstextarea: '.field_type_textarea',
	input: '.js-field-input',
	inputTwice: '.js-field-input-twice',
	jsinputTwice: '.field_type_twice'
};

const classes = {
	show: 'field__eye_state_show',
	error: 'field__input_state_error',
	focus: 'field_type_twice_focus'
};

const showPass = () => {
	const pass = document.querySelector(selectors.pass);
	const eye = document.querySelector(selectors.show);

	if (pass.getAttribute('type') === 'password') {
		pass.setAttribute('type', 'text');
		eye.classList.toggle(classes.show);
	} else {
		pass.setAttribute('type', 'password');
		eye.classList.toggle(classes.show);
	}
};

const removeError = e => {
	const target = e.target;
	const el = target.closest(selectors.jstextarea);
	if (el === null) {
		target.classList.remove(classes.error);
	} else {
		el.classList.remove(classes.error);
	}
};

const focusInTwice = e => {
	const target = e.target;
	const el = target.closest(selectors.jsinputTwice);
	el.classList.add(classes.focus);
};

const focusOutTwice = e => {
	const target = e.target;
	const el = target.closest(selectors.jsinputTwice);
	el.classList.remove(classes.focus);
};

const render = () => {
	if (selectors.textarea) {
		$(selectors.textarea).scrollbar();
		bindEvent(selectors.textarea, 'focus', removeError);
	}
	if (selectors.select) {
		bindEvent(selectors.select, 'change', removeError);
	}
	if (isElement(selectors.pass)) {
		bindEvent(selectors.show, 'click', showPass);
	}
	bindEvent(selectors.inputTwice, 'focusin', focusInTwice);
	bindEvent(selectors.inputTwice, 'focusout', focusOutTwice);
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/field/index.js